var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"color":"green","dark":"","app":""}},[_c('v-btn',{attrs:{"icon":"","title":"Voltar ao formulário"},on:{"click":_vm.$_voltar}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1),_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.titulo)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }